import { atom } from 'recoil';

export const oauth2Atom = atom({
  key: 'oauth2Atom',
  default: {
    loading: true,
    item: {},
    items: [],
    error: Error
  },
});